import { useSessionEhrProvider } from '@/hooks/integrations/useSessionEhrProvider';
import { logger } from '@/utils/logger/logger';
import { resolveDocumentContentType } from '@/utils/resolveDocumentContentType';
import { useIsFreeUser } from '@heidi/commerce/data';
import { toast } from '@heidi/design-system/toast';
import { sanitizeError } from '@heidi/runtime/logger';
import { useMutateCreateDocumentFromAskAI as useMutateCreateDocumentFromAskAICore } from '@heidi/session/data';
import { AxiosError } from 'axios';
import { get } from 'lodash-es';
import { useEnableBlockEditorV1 } from '../useEnableBlockEditorV1';

export function useMutateCreateDocumentFromAskAI(sessionId: string) {
  const { sessionEhrProvider } = useSessionEhrProvider(sessionId);
  const enableBlockEditorV1 = useEnableBlockEditorV1(sessionEhrProvider);
  const { isFreeUser } = useIsFreeUser();

  return useMutateCreateDocumentFromAskAICore(sessionId, {
    resolveContentType: resolveDocumentContentType,
    enableBlockEditorV1,
    isFreeUser,
    onCreateError: (error) => {
      logger.error('Error:', { error: sanitizeError(error) });

      if (error instanceof AxiosError) {
        toast({
          tone: 'destructive',
          title: 'Failed to create document',
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
          description: get(error.response, 'data.detail.message', error.message),
        });
      }
    },
  });
}
